import { createContext } from 'react'

const EnrolledPersonContext = createContext<boolean>(true)

export default EnrolledPersonContext
